/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Represents the information that can be displayed on the proposal sent to the client1 = Code

2 = Description

3 = Qty / unit

4 = Builder unit cost

5 = Builder total cost

6 = Markup %

7 = Markup amount

8 = Unit price

9 = Price

10 = Total price

11 = Group price

13 = Total cost

14 = Total markup

15 = Item type

16 = Item title

17 = Cost type

18 = Tax

19 = Tax status

22 = Marked as

23 = Total approved options

24 = Subgroup price

25 = Parent group price

26 = Subtotal

27 = Total price

28 = Subgroup price

29 = Parent group price

30 = Specs


 */
export type ProposalColumnTypes =
  (typeof ProposalColumnTypes)[keyof typeof ProposalColumnTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProposalColumnTypes = {
  CostCode: 1,
  Description: 2,
  QuantityAndUnit: 3,
  UnitCost: 4,
  BuilderCost: 5,
  Markup: 6,
  MarkupAmount: 7,
  UnitPrice: 8,
  OwnerPrice: 9,
  TotalOwnerPrice: 10,
  CategoryOwnerPrice: 11,
  TotalCost: 13,
  TotalMarkup: 14,
  ItemType: 15,
  ItemTitle: 16,
  CostType: 17,
  TotalTax: 18,
  TaxableStatus: 19,
  MarkedAs: 22,
  TotalApprovedOptions: 23,
  SubgroupPrice: 24,
  ParentGroupPrice: 25,
  Subtotal: 26,
  TotalPriceWithTax: 27,
  SubgroupPriceWithTax: 28,
  ParentGroupPriceWithTax: 29,
  Specs: 30,
} as const;
